<template>
  <div
    v-if="step === 'getEmail'"
    class="w-full"
  >
    <h1 class="text-xl text-center mb-2">
      {{ $t('mycountly.signup.unlock-account') }}
    </h1>
    <p class="text-sm text-center text-neutral-500 mb-6">
      {{ $t('mycountly.signup.please-enter-your-account-email') }}
      {{ $t('mycountly.signup.receive-instructions-on-unlocking-account') }}
    </p>
    <cly-request
      disable-loading-icon
      silent-error
      @success="onSendLinkSuccess"
      @error="onSendLinkError"
    >
      <template #default="request">
        <cly-form @enter="request.submit(getSendLinkSubmission)">
          <template #default="v">
            <cly-form-step id="signupStep">
              <cly-form-field
                :rules="'required|email|max:320'"
                :label="$t('mycountly.signup.email-address')"
              >
                <el-input
                  v-model="email"
                  type="email"
                  class="w-full mt-1"
                  :placeholder="$t('mycountly.signup.placeholder.enter-your-email')"
                />
              </cly-form-field>
              <myc-big-button
                :disabled="request.pending || !v.isSubmissionAllowed"
                type="success"
                class="w-full !mt-5"
                @clicked="request.submit(getSendLinkSubmission)"
              >
                {{ $t('mycountly.signup.send-email') }}
              </myc-big-button>
            </cly-form-step>
          </template>
        </cly-form>
      </template>
    </cly-request>
    <p class="text-center mt-6 text-neutral-500 text-[13px]">
      <router-link
        class="!text-[#1EAB56] hover:!text-[#178f47]"
        to="/signin"
      >
        {{ $t('mycountly.signup.back-to-login') }}
      </router-link>
    </p>
  </div>
  <div
    v-else-if="step === 'mailSent'"
    class="w-full text-center"
  >
    <img
      class="w-16 h-16 mx-auto"
      src="@/assets/images/check.svg"
    >
    <h1 class="text-xl text-center mt-6 mb-2">
      {{ $t('mycountly.signup.unlock-email-sent') }}
    </h1>
    <p class="text-sm text-center text-neutral-500">
      {{ $t('mycountly.signup.an-email-has-been-sent', { 0: email }) }}
    </p>
    <p class="text-sm text-center text-neutral-500 mb-6">
      {{ $t('mycountly.signup.follow-directions-in-the-email-to-unlock') }}
    </p>
    <router-link to="/signin">
      <myc-big-button
        type="success"
        class="w-full !mt-5"
      >
        {{ $t('mycountly.signup.back-to-login') }}
      </myc-big-button>
    </router-link>
  </div>
</template>

<script>
import { mapActions } from 'pinia';
import { useAuthStore } from '@/stores';
import { PreloginNavigationMixin } from '@/utils/mixins/prelogin-navigation';
import ClyFormField from '@/components/countly/lib-components/form/cly-form-field.vue';
import ClyForm from '@/components/countly/lib-components/form/cly-form.vue';
import ClyFormStep from '@/components/countly/lib-components/form/cly-form-step.vue';
import MycBigButton from '@/components/common/myc-big-button.vue';

export default {
  components: {
    MycBigButton,
    ClyForm,
    ClyFormStep,
    ClyFormField,
  },
  mixins: [PreloginNavigationMixin],
  data() {
    return {
      email: '',
      /*
          Steps:
          1. 'getEmail' - it shows the form to get the password reset email
          2. 'mailSent' - it's informs user that the email has been sent
        */
      step: 'getEmail',
      submissionAllowed: true,
      token: '',
    };
  },
  async created() {
    this.tryResuming(this.$router);
    if (this.$route.query.mailSent) {
      this.step = 'mailSent';
    } else {
      this.step = 'getEmail';
    }
  },
  methods: {
    ...mapActions(useAuthStore, ['submitSendUnlockAccountEmail']),
    getSendLinkSubmission() {
      return this.submitSendUnlockAccountEmail({ email: this.email });
    },
    onSendLinkSuccess() {
      this.step = 'mailSent';
    },
    onSendLinkError(result) {
      this.$clyNotify({ message: this.$t(result.message), sticky: false, type: 'error' });
    },
  },
};
</script>
